<section class="section about" id='about'>
    <div class="container">
        <div class="section-box">
            <div class="about-title" data-aos="fade-up">
                <h3 class="section-title">
                    <span class='n-section-title'>01.</span> {{"AboutMe.Title" | translate}}
                </h3>
            </div>
            <div class="row">
                <div class="col-12 col-md-6 mb-4 mb-md-0">
                    <div class="about-description">
                        <p *ngFor='let text of "AboutMe.Paragraphs" | translate' [innerHTML]="text" data-aos="fade-up" data-aos-duration="1000">
                        </p>
                        <ul class="skills-list" data-aos="fade-up">
                            <li class="skill-element" data-aos="fade-up" data-aos-duration="1000"><span class="underline">Python, SQL </span></li>
                            <li class="skill-element" data-aos="fade-up" data-aos-duration="1000"><span class="underline">PyTorch, TensorFlow </span></li>
                            <li class="skill-element" data-aos="fade-up" data-aos-duration="1000"><span class="underline"> Statistical analysis & modeling</span></li>
                            <li class="skill-element" data-aos="fade-up" data-aos-duration="1000"><span class="underline"> Tableau </span></li>
                            <li class="skill-element" data-aos="fade-up" data-aos-duration="1000"><span class="underline">NodeJS </span></li>
                            <li class="skill-element" data-aos="fade-up" data-aos-duration="1000"><span class="underline">Angular </span></li>
                            <li class="skill-element" data-aos="fade-up" data-aos-duration="1000"><span class="underline">Docker and Kubernetes </span></li>
                            <li class="skill-element" data-aos="fade-up" data-aos-duration="1000"><span class="underline"> C/C++, C# </span></li>
                            <li class="skill-element" data-aos="fade-up" data-aos-duration="1000"><span class="underline"> JavaScript, TypeScript </span></li>
                            <li class="skill-element" data-aos="fade-up" data-aos-duration="1000"><span class="underline">Bootstrap, Material </span></li>
                        </ul>
                    </div>
                </div>
                <div class="col-12 col-md-6 mt-4 mt-md-0 text-center" data-aos="fade-up" data-aos-duration="1000">
                    <div class="about-img-container">
                        <img (click)='analyticsService.sendAnalyticEvent("click_image", "about", "image")'  width="300" height="300" src="assets/images/me/1687583442100.jpeg" alt="Git User">
                    </div>
                </div>

            </div>
        </div>
    </div>
</section>
